import React, { useEffect, useMemo, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import i18n from 'utils/I18n';
import LoginMethodContactModal from 'component/account/LoginMethodContactModal';
import MyAccountChangePassword from 'component/account/MyAccountChangePassword';
import MyAccountDeleteAccount from 'component/account/MyAccountDeleteAccount';
import MyAccountMergeHistory from 'component/account/MyAccountMergeHistory';
import MyAccountLogout from 'component/account/MyAccountLogout';
import MyAccountDirectMarketing from './MyAccountDirectMarketing';
import {
  CUSTOMER_SIGN_UP_METHOD,
  CustomerFieldName,
  GenderType,
  ProfileEditState,
  ProfileEditType,
} from 'utils/CustomEnums';
import {
  PRIMARY_SIGN_UP_METHOD,
  USE_RECAPTCHA,
  RECAPTCHA_SITE_KEY,
} from 'utils/Config';
import {
  MOBILE_AND_EMAIL_BOTH_FOR_SIGN_UP,
  LOGIN_SHOW_EDIT_BUTTON,
  LOGIN_SHOW_CUSTOMER_SERVICE,
  SECOND_CONTACT_SHOW,
  SECOND_CONTACT_SHOW_EDIT_BUTTON,
  SECOND_CONTACT_SHOW_CUSTOMER_SERVICE,
  SECOND_CONTACT_OPTIONAL,
} from 'utils/LoginOrSecondContactUtils';
import './MyAccountInfoSection.scss';
import './MyAccountMobile.scss';
import AdditionalDataSection from 'component/account/AdditionalDataSection';
import CustomerContactModal from './CustomerContactModal';
import {
  FirstNameSection,
  LastNameSection,
  GenderSection,
  BirthdaySection,
  SingleLoginOrContactSection
} from './MyAccountDefaultSection';

import { ReactComponent as NoticeImg } from 'assets/images/Info.svg';

const SecondContactSection = ({
  showEmail,
  email,
  showMobile,
  countryCodeAndPhoneNumber,
  contactForDirectMarketingEditState,
  setEditType,
  showSecondLoginMethodModal,
  hideSecondLoginMethodModal,
  setShowCustomerContactModal,
}) => {
  if (!SECOND_CONTACT_SHOW) {
    return null;
  };
  const directMarketingTitle = i18n.t('settings_contact_for_direct_marketing') + (SECOND_CONTACT_OPTIONAL ? i18n.t('personal_info_optional') : "")
  return (
    <>
      <div className="common-item-title contact-for-direct-marketing-title subheading">
        {directMarketingTitle}
      </div>
      {
        PRIMARY_SIGN_UP_METHOD === CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS
          ? <SingleLoginOrContactSection
            show={showMobile}
            contactValue={countryCodeAndPhoneNumber}
            showEdit={SECOND_CONTACT_SHOW_EDIT_BUTTON}
            showCustomerService={SECOND_CONTACT_SHOW_CUSTOMER_SERVICE}
            contactForDirectMarketingEditState={contactForDirectMarketingEditState}
            setEditType={setEditType}
            showSecondLoginMethodModal={() => showSecondLoginMethodModal(CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER)}
            hideSecondLoginMethodModal={hideSecondLoginMethodModal}
            setShowCustomerContactModal={setShowCustomerContactModal}
          />
          : <SingleLoginOrContactSection
            show={showEmail}
            contactValue={email}
            showEdit={SECOND_CONTACT_SHOW_EDIT_BUTTON}
            showCustomerService={SECOND_CONTACT_SHOW_CUSTOMER_SERVICE}
            contactForDirectMarketingEditState={contactForDirectMarketingEditState}
            setEditType={setEditType}
            showSecondLoginMethodModal={() => showSecondLoginMethodModal(CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS)}
            hideSecondLoginMethodModal={hideSecondLoginMethodModal}
            setShowCustomerContactModal={setShowCustomerContactModal}
          />
      }
    </>
  )
};

const MobileAndEmailSection = ({
  userInfo,
  showEmail,
  email,
  showMobile,
  countryCodeAndPhoneNumber,
  contactForDirectMarketingEditState,
  setEditType,
  showSecondLoginMethodModal,
  hideSecondLoginMethodModal,
  setShowCustomerContactModal,
}) => {
  const { signUpMethod, tempEmailAddress, tempCountryCode, tempPhoneNumber } = userInfo;
  const showAddLoginOrContactButton = useMemo(
    () => {
      // mobile and email both have value
      if (signUpMethod === CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS) {
        return false;
      };
      // mobile and email both for sign up
      if (MOBILE_AND_EMAIL_BOTH_FOR_SIGN_UP) {
        return true;
      };
      // show second contact 
      if (SECOND_CONTACT_SHOW) {
        return true;
      };
      return false;
    },
    [signUpMethod]
  );

  const secondLoginMethod = signUpMethod === CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS
    ? CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER
    : CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS

  const displayEmailMethodSection = MOBILE_AND_EMAIL_BOTH_FOR_SIGN_UP
    || PRIMARY_SIGN_UP_METHOD === CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS
  const displayMobileMethodSection = MOBILE_AND_EMAIL_BOTH_FOR_SIGN_UP
    || PRIMARY_SIGN_UP_METHOD === CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER
  const displayAddSecondContact = !MOBILE_AND_EMAIL_BOTH_FOR_SIGN_UP

  const addSecondLoginMethodItem = () => {
    if (!showAddLoginOrContactButton) {
      return <></>
    }

    let tempContact = ""
    if (
      secondLoginMethod === CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER
      && tempPhoneNumber
    ) {
      tempContact = `${tempCountryCode || ""} ${tempPhoneNumber}`
    } else if (
      secondLoginMethod === CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS
      && tempEmailAddress
    ) {
      tempContact = tempEmailAddress
    }
    return (
      <>
        <div className='second-contact-line'>
          {tempContact &&
            <div className='field-text temp-second-contact'>
              {tempContact}
            </div>
          }
          <button
            className="add-another-btn button-small subheading"
            onClick={() =>
              showSecondLoginMethodModal(secondLoginMethod)
            }
          >
            {tempContact ? i18n.t('verify_now') : i18n.t('settings_login_add_second_method')}
          </button>
        </div>
        {MOBILE_AND_EMAIL_BOTH_FOR_SIGN_UP && tempContact ?
          <div className='second-contact-verify-tips tag-menu-1'>
            <NoticeImg className="notice-img" />
            {i18n.t('sencond_login_method_tips')}
          </div> : null}
      </>
    )
  }
  return (
    <>
      {displayEmailMethodSection ?
        <SingleLoginOrContactSection
          show={showEmail}
          contactValue={email}
          showEdit={LOGIN_SHOW_EDIT_BUTTON}
          showCustomerService={LOGIN_SHOW_CUSTOMER_SERVICE}
          contactForDirectMarketingEditState={contactForDirectMarketingEditState}
          setEditType={setEditType}
          showSecondLoginMethodModal={() => showSecondLoginMethodModal(CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS)}
          hideSecondLoginMethodModal={hideSecondLoginMethodModal}
          setShowCustomerContactModal={setShowCustomerContactModal}
        /> : null}
      {displayMobileMethodSection ?
        <SingleLoginOrContactSection
          show={showMobile}
          contactValue={countryCodeAndPhoneNumber}
          showEdit={LOGIN_SHOW_EDIT_BUTTON}
          showCustomerService={LOGIN_SHOW_CUSTOMER_SERVICE}
          contactForDirectMarketingEditState={contactForDirectMarketingEditState}
          setEditType={setEditType}
          showSecondLoginMethodModal={() => showSecondLoginMethodModal(CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER)}
          hideSecondLoginMethodModal={hideSecondLoginMethodModal}
          setShowCustomerContactModal={setShowCustomerContactModal}
        /> : null
      }
      {displayAddSecondContact ? 
        <SecondContactSection
          showEmail={showEmail}
          email={email}
          showMobile={showMobile}
          countryCodeAndPhoneNumber={countryCodeAndPhoneNumber}
          contactForDirectMarketingEditState={contactForDirectMarketingEditState}
          setEditType={setEditType}
          showSecondLoginMethodModal={showSecondLoginMethodModal}
          hideSecondLoginMethodModal={hideSecondLoginMethodModal}
          setShowCustomerContactModal={setShowCustomerContactModal}
        /> : null
      }
      {addSecondLoginMethodItem()}
    </>
  );
};

const MyAccountMobile = ({
  profileFieldsConfig,
  language,
  signUpMethod,
  countryCode,
  phoneNumber,
  email,
  userInfo,
  additionalDataSectionConfig
}) => {
  const genderList = useMemo(() => [
    {
      name: i18n.t('personal_info_male'),
      pk: GenderType.Male,
    },
    {
      name: i18n.t('personal_info_female'),
      pk: GenderType.Female,
    },
    {
      name: i18n.t('personal_info_not_disclosed'),
      pk: GenderType.NotDisclosed,
    },
  ], [language]);

  const dispatch = useDispatch();
  const firstNameConfig = useMemo(
    () =>
      profileFieldsConfig?.filter(
        (item) => item.fieldName === CustomerFieldName.firstName
      )?.[0],
    [profileFieldsConfig]
  );
  const lastNameConfig = useMemo(
    () =>
      profileFieldsConfig?.filter(
        (item) => item.fieldName === CustomerFieldName.lastName
      )?.[0],
    [profileFieldsConfig]
  );
  const genderConfig = useMemo(
    () =>
      profileFieldsConfig?.filter(
        (item) => item.fieldName === CustomerFieldName.gender
      )?.[0],
    [profileFieldsConfig]
  );
  const birthdayConfig = useMemo(
    () =>
      profileFieldsConfig?.filter(
        (item) => item.fieldName === CustomerFieldName.birthday
      )?.[0],
    [profileFieldsConfig]
  );

  const [showLoginMethodModal, setShowLoginMethodModal] = useState(false);
  const [modalMethod, setModalMethod] = useState(null);
  const [showCustomerContactModal, setShowCustomerContactModal] = useState({
    show: false,
    isForSecondContact: false,
  });

  const closeCustomerContactModal = () => {
    setShowCustomerContactModal({
      show: false,
      isForSecondContact: false,
    });
  };

  const displayGender = useMemo(() => {
    const userGender = userInfo.gender;
    if (userGender === GenderType.Female) {
      return i18n.t('personal_info_female');
    }
    if (userGender === GenderType.Male) {
      return i18n.t('personal_info_male');
    }
    if (userGender === GenderType.NotDisclosed) {
      return i18n.t('personal_info_not_disclosed');
    }
    return i18n.t('not_provided');
  }, [userInfo.gender, language]);

  const [editType, setEditType] = useState(null);
  const firstNameEditState = useMemo(() => {
    if (editType === ProfileEditType.FirstName) {
      return ProfileEditState.Editing;
    }
    if (editType) {
      return ProfileEditState.Disable;
    }
    return ProfileEditState.Normal;
  }, [editType]);
  const lastNameEditState = useMemo(() => {
    if (editType === ProfileEditType.LastName) {
      return ProfileEditState.Editing;
    }
    if (editType) {
      return ProfileEditState.Disable;
    }
    return ProfileEditState.Normal;
  }, [editType]);
  const genderEditState = useMemo(() => {
    if (editType === ProfileEditType.Gender) {
      return ProfileEditState.Editing;
    }
    if (editType) {
      return ProfileEditState.Disable;
    }
    return ProfileEditState.Normal;
  }, [editType]);
  const birthdayEditState = useMemo(() => {
    if (editType === ProfileEditType.Birthday) {
      return ProfileEditState.Editing;
    }
    if (editType) {
      return ProfileEditState.Disable;
    }
    return ProfileEditState.Normal;
  }, [editType]);
  const contactForDirectMarketingEditState = useMemo(() => {
    if (editType === ProfileEditType.contactForDirectMarketing) {
      return ProfileEditState.Editing;
    }
    if (editType) {
      return ProfileEditState.Disable;
    }
    return ProfileEditState.Normal;
  }, [editType]);

  const countryCodeAndPhoneNumber = useMemo(
    () => (
      countryCode && phoneNumber
        ? `+${countryCode} ${phoneNumber}`
        : null
    ),
    [countryCode, phoneNumber],
  );
  const showMobile = useMemo(
    () => [
      CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER,
      CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS,
    ].includes(signUpMethod),
    [signUpMethod],
  )
  const showEmail = useMemo(
    () => [
      CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS,
      CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS,
    ].includes(signUpMethod),
    [signUpMethod],
  )

  const loadRecaptcha = () =>  {
    if (window?.grecaptcha && window?.grecaptcha?.enterprise) {
      console.log("reCAPTCHA already loaded");
      return;
    }

    const existingScript = document.querySelector('script[src*="recaptcha/enterprise.js"]');
    if (existingScript) {
      console.log("reCAPTCHA script already exists");
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.recaptcha.net/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    
    script.onload = () => {
      if (window?.grecaptcha && window?.grecaptcha?.enterprise) {
        console.log("window.grecaptcha.enterprise ok")
      }
    };

    script.onerror = (error) => {
      console.error('load reCAPTCHA error:', error);
    };
  
    document.head.appendChild(script);
  }

  const removeRecaptcha = () => {
    const existingScript = document.querySelector('script[src*="recaptcha/enterprise.js"]');
    if (existingScript) {
      existingScript.remove();
      console.log("reCAPTCHA script removed");
    }

    const recaptchaElements = document.querySelectorAll('.grecaptcha-badge, .grecaptcha-logo, iframe[src*="recaptcha"]');
    recaptchaElements.forEach(element => {
      element.remove();
    });

    if (recaptchaElements.length > 0) {
      console.log(`Removed ${recaptchaElements.length} reCAPTCHA DOM elements`);
    }

    if (window.grecaptcha) {
      delete window.grecaptcha;
      console.log("window.grecaptcha object removed");
    }

    const recaptchaStyles = document.querySelectorAll('link[href*="recaptcha"], style[data-href*="recaptcha"]');
    recaptchaStyles.forEach(style => {
      style.remove();
    });

    console.log("reCAPTCHA cleanup completed");
  }

  const showSecondLoginMethodModal = (editMethod) => {
    setEditType(ProfileEditType.LoginAndContact);
    setModalMethod(editMethod);
    setShowLoginMethodModal(true);
    if (USE_RECAPTCHA) {
      loadRecaptcha();
    }
  };
  const hideSecondLoginMethodModal = () => {
    setEditType(null);
    setShowLoginMethodModal(false);
    setModalMethod(null);
    if (USE_RECAPTCHA) {
      removeRecaptcha();
    }
  };

  const [firstName, setFirstName] = useState(userInfo.firstName);
  const [lastName, setLastName] = useState(userInfo.lastName);
  const [birthday, setBirthday] = useState(userInfo.birthday);
  const [selectedGender, setSelectedGender] = useState(userInfo.gender);
  useEffect(() => {
    setFirstName(userInfo.firstName);
    setLastName(userInfo.lastName);
    setBirthday(userInfo.birthday);
    setSelectedGender(userInfo.gender);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editType]);

  useEffect(() => {
    return () => {
      dispatch({
        type: 'userInfoTemp/clearState',
        payload: {},
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="account-mobile-common-section">
        <div className="common-section-title title-medium-2">
          {i18n.t('account_information')}
        </div>
        <FirstNameSection
          show={firstNameConfig?.show}
          mandatory={firstNameConfig?.mandatory}
          editable={firstNameConfig?.editable}
          firstNameEditState={firstNameEditState}
          setEditType={setEditType}
          userInfo={userInfo}
          firstName={firstName}
          setFirstName={setFirstName}
        />
        <LastNameSection
          show={lastNameConfig?.show}
          mandatory={lastNameConfig?.mandatory}
          editable={lastNameConfig?.editable}
          lastNameEditState={lastNameEditState}
          setEditType={setEditType}
          userInfo={userInfo}
          lastName={lastName}
          setLastName={setLastName}
        />
        <GenderSection
          show={genderConfig?.show}
          mandatory={genderConfig?.mandatory}
          editable={genderConfig?.editable}
          genderEditState={genderEditState}
          setEditType={setEditType}
          genderList={genderList}
          userInfo={userInfo}
          selectedGender={selectedGender}
          setSelectedGender={setSelectedGender}
          displayGender={displayGender}
        />
        <BirthdaySection
          show={birthdayConfig?.show}
          mandatory={birthdayConfig?.mandatory}
          editable={birthdayConfig?.editable}
          birthdayEditState={birthdayEditState}
          setEditType={setEditType}
          userInfo={userInfo}
          birthday={birthday}
          setBirthday={setBirthday}
          language={language}
        />

        <div className="common-account-item">
          <div className="common-item-title subheading">
            {i18n.t('settings_login_and_contact')}
          </div>

          <MobileAndEmailSection
            userInfo={userInfo}
            showEmail={showEmail}
            email={email}
            showMobile={showMobile}
            countryCodeAndPhoneNumber={countryCodeAndPhoneNumber}
            contactForDirectMarketingEditState={contactForDirectMarketingEditState}
            setEditType={setEditType}
            showSecondLoginMethodModal={showSecondLoginMethodModal}
            hideSecondLoginMethodModal={hideSecondLoginMethodModal}
            setShowCustomerContactModal={setShowCustomerContactModal}
          />
        </div>
      </div>

      <div>
        <MyAccountDirectMarketing />
      </div>

      {additionalDataSectionConfig?.map(sectionConfig => (
        <div>
          <AdditionalDataSection sectionConfig={sectionConfig} isMobileView={true} />
        </div>
      ))}

      <div>
        <MyAccountChangePassword />
      </div>

      <div>
        <MyAccountMergeHistory />
      </div>

      <div>
        <MyAccountDeleteAccount />
      </div>

      <div>
        <MyAccountLogout />
      </div>

      <LoginMethodContactModal
        showModal={showLoginMethodModal}
        modalMethod={modalMethod}
        onClose={() => hideSecondLoginMethodModal()}
        setShowCustomerContactModal={setShowCustomerContactModal}
      />
      <CustomerContactModal
        showCustomerContactModal={showCustomerContactModal}
        onClose={closeCustomerContactModal}
      />
    </div>
  );
};

const mapStateToProps = ({ userInfoTemp, users, config }) => {
  return {
    ...userInfoTemp,
    profileFieldsConfig: config.profileFieldsConfig,
    additionalDataSectionConfig: config.additionalDataSectionConfig,
    language: users.language,
    signUpMethod: users.userInfo.signUpMethod,
    countryCode: users.userInfo.countryCode,
    phoneNumber: users.userInfo.phoneNumber,
    email: users.userInfo.emailAddress,
    userInfo: users.userInfo,
  };
};

export default connect(mapStateToProps)(withTranslation()(MyAccountMobile));
